import React from 'react'
import { Alert, Spinner } from 'react-bootstrap'

function StockRangeInfo({ range, loading, error }) {
  if (loading) {
    return (
      <Spinner animation="border" size="sm" role="status">
        <span className="visually-hidden">Loading…</span>
      </Spinner>
    )
  }
  if (error) {
    return (
      <Alert variant="danger" role="alert">
        {error}
      </Alert>
    )
  }
  if (!range) return null
  return (
    <p className="text-muted small mb-3">
      Data available from <strong>{range.oldest_date}</strong> to{' '}
      <strong>{range.newest_date}</strong> — last updated{' '}
      <strong>{range.last_updated}</strong>
    </p>
  )
}

export default StockRangeInfo
